import { Box } from '@chakra-ui/react';

export default function LaptopWithPeople(props) {
  return (
    <Box {...props}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.75 35.25L47.25 35.25V36C47.25 38.8995 44.8995 41.25 42 41.25H6C3.10051 41.25 0.75 38.8995 0.75 36V35.25Z"
          fill="white"
          stroke="#25383F"
          strokeWidth="1.5"
        />
        <path
          d="M15 35.25V35.25C15 36.9069 16.3431 38.25 18 38.25H31.5C33.1569 38.25 34.5 36.9069 34.5 35.25V35.25"
          stroke="#25383F"
          strokeWidth="1.5"
        />
        <path
          d="M4.5 6.75V6.75H43.5V33.75H4.5V6.75Z"
          fill="white"
          stroke="#25383F"
          strokeWidth="1.5"
        />
        <rect x="11.25" y="12.75" width="25.5" height="15" rx="0.75" fill="#8BBFD0" />
        <circle cx="24" cy="17.25" r="2.25" fill="white" />
        <circle cx="31.5" cy="16.5" r="1.5" fill="white" />
        <circle cx="16.5" cy="16.5" r="1.5" fill="white" />
        <path
          d="M19.5 25.5C19.5 24.9091 19.6164 24.3239 19.8425 23.7779C20.0687 23.232 20.4002 22.7359 20.818 22.318C21.2359 21.9002 21.732 21.5687 22.2779 21.3425C22.8239 21.1164 23.4091 21 24 21C24.5909 21 25.1761 21.1164 25.7221 21.3425C26.268 21.5687 26.7641 21.9002 27.182 22.318C27.5998 22.7359 27.9313 23.232 28.1575 23.7779C28.3836 24.3239 28.5 24.9091 28.5 25.5L24 25.5L19.5 25.5Z"
          fill="white"
        />
        <path
          d="M28.5 21.75C28.5 21.356 28.5776 20.9659 28.7284 20.602C28.8791 20.238 29.1001 19.9073 29.3787 19.6287C29.6573 19.3501 29.988 19.1291 30.352 18.9784C30.7159 18.8276 31.106 18.75 31.5 18.75C31.894 18.75 32.2841 18.8276 32.6481 18.9784C33.012 19.1291 33.3427 19.3501 33.6213 19.6287C33.8999 19.9073 34.1209 20.238 34.2716 20.6019C34.4224 20.9659 34.5 21.356 34.5 21.75L31.5 21.75L28.5 21.75Z"
          fill="white"
        />
        <path
          d="M13.5 21.75C13.5 21.356 13.5776 20.9659 13.7284 20.602C13.8791 20.238 14.1001 19.9073 14.3787 19.6287C14.6573 19.3501 14.988 19.1291 15.352 18.9784C15.7159 18.8276 16.106 18.75 16.5 18.75C16.894 18.75 17.2841 18.8276 17.6481 18.9784C18.012 19.1291 18.3427 19.3501 18.6213 19.6287C18.8999 19.9073 19.1209 20.238 19.2716 20.6019C19.4224 20.9659 19.5 21.356 19.5 21.75L16.5 21.75L13.5 21.75Z"
          fill="white"
        />
      </svg>
    </Box>
  );
}
